import { createContext, useContext } from 'react';
import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { INavigationConfig } from '~/src/dash/views/common';

interface IPlatformConnectsContext {
  cfg: INavigationConfig;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
  forceUpdate: (tabIndex: number) => void;
}

export const PlatformConnectsContext = createContext({} as IPlatformConnectsContext);
export const usePlatformConnectsStore = (): IPlatformConnectsContext =>
  useContext(PlatformConnectsContext);
